import React from 'react';
import './Banner.css'

const Banner = () => {
    return (
        <div className="container">
            <div className="row">
                <div className="col-lg-6"></div>
                <div className="col-lg-6">
                    <div className="the-heading-part py-4 d-flex align-content-end flex-wrap">
                        <h1>
                        
                              </h1>
                        
                        
                    </div>
                </div>

            </div>
        </div>
    );
};

export default Banner;